export const minBatchPreviewColumnsWidth = {
  method: 88,
  'payment.amount': 97,
  'payment.currency': 76,
  'card.year': 60,
  'card.month': 60,
  'customer.day_of_birth': 81,
};
